import * as types from '../types'
import moment from 'moment'
import update from 'immutability-helper'


export const initialSearchFilter = {
    ApplyDateFilters: true,
    ApplicationDateStart: moment().startOf('month').format('MM/DD/YYYY'),
    ApplicationDateEnd: moment().endOf('month').format('MM/DD/YYYY'),
    ControlNo: '',
    EmployeeId: '',
    BatchId: '',
    DepartmentId: '',
    SectionId: '',
    IncomeId: '',
    Approval: -1,
    Adjusted: -1,
    Pagination: {
        Page: 0,
        PageSize: 30,
    },
    Sort: {
        field: 'incAdjApplicationDate',
        sort: 'desc'
    }
}

const defaultState = {
    reducerVariable: 'Income Adjustment',
    searchLabel: 'Income Adjustment Search',
    searchFilter: {
        ...initialSearchFilter
    },
    resultTable: {
        // Applied Filter from search from
        appliedFilter: {
            ...initialSearchFilter
        },
        // Table Data
        loading: true,
        data: [],
        totalCount: 0
    },
    confirmModal: {
        show: false,
        title: 'Confirm Deletion',
        message: 'Do you want to delete this record?',
        confirmData: null, // Set the data to be passed in confirm
        onConfirm: () => {},
        onClose: () => {},
    }
}

// Define how the states will change based on the dispatched action
export default function listReducer(state = defaultState, action) {
    switch (action.type) {
    default: return state
    }
}
